export default __webpack_public_path__ + "static/br-918a85c0fbe30c8e211a35e0794ebaa8.svg";